import type { FaireProductEntity } from "../../entity_types/product";

export const p_tw6xfedv7k: FaireProductEntity = {
  token: "p_tw6xfedv7k",
  type: "product",
  name: "Fireside Frozen Cocoa Frozen Cocktail-Just add water + Vodka",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/c13a9cd56d40eb0a6fedf346aee0a6855a771663422d135c703226bd24c83673.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b4509d9dfdd842ccd0668278f50c3c1526a6f463afe635e2397ad504c9c481c.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Seasonal Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1.5 cups of tequila and 4.5 cups of water (total 6 cups of liquid), shake or stir and throw in the freezer. Then serve right from the bag. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party.\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and holiday design makes merchandising a breeze!\n-Perfect Christmas and hostess gifts for the entire holiday season",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:01.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
